var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.65 16.96L12.5 12.8l1.61-1.61a.64.64 0 0 1 .9 0l3.24 3.23c.25.25.25.66 0 .9l-.71.72-.66.66-.22.26zm3.42 6.78a36.47 36.47 0 0 1-3.8-3.81 2.05 2.05 0 0 1-.33-2.04l-4.26-4.27c-1 1.02-.87 3.55.22 5.78.46.96 1.07 1.83 1.7 2.66a23.81 23.81 0 0 0 4.35 4.36c.82.63 1.7 1.23 2.65 1.7 2.23 1.08 4.76 1.2 5.78.2l-4.27-4.26c-.68.25-1.48.16-2.04-.32zM28.82 25l-3.24-3.24a.64.64 0 0 0-.9 0h-.01l-.71.71-.66.66a2 2 0 0 1-.26.22l4.16 4.16 1.6-1.61a.63.63 0 0 0 .02-.9z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
});